import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { BriefLocationIcon, DetailLocationIcon } from './icons';

const getLocationStyles = () => ({
  locationContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  locationTextBrief: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: '#000000',
    margin: '0 0 4px 4px',
  },
  locationTextDetail: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px',
    color: '#4007A2',
    marginLeft: 4,
  },
});

export const Location = ({ showDetailLocation, locationText }) => {
  const classes = useDefaultStyles(getLocationStyles);

  return (
    <div
      className={classNames(classes.locationContainer, 'location-container')}
    >
      <div className={classNames(classes.locationIcon, 'location-icon')}>
        {showDetailLocation ? <DetailLocationIcon /> : <BriefLocationIcon />}
      </div>
      {locationText && (
        <div className={classNames(showDetailLocation ? classes.locationTextDetail : classes.locationTextBrief, 'location-text')}>
          {locationText}
        </div>
      )}
    </div>
  );
};

Location.propTypes = {
  showDetailLocation: PropTypes.bool,
  locationText: PropTypes.string,
};

Location.defaultProps = {
  showDetailLocation: true,
  locationText: undefined,
};
